export const createListData = (values, offers) => {
    if (!offers)
        return [];
    return values.items.reduce((previous, current) => {
        const offer = offers.find((offer) => {
            return offer.variants.some((variant) => variant.id === current.variantId);
        });
        if (!offer)
            return previous;
        const variant = offer.variants.find((variant) => variant.id === current.variantId);
        if (!variant)
            return previous;
        const image = offer.images?.find((image) => image.id === variant.images[0]) || offer.primaryImage?.thumbnail;
        const item = {
            id: variant.id,
            name: offer.name,
            description: variant.attributesDescription,
            image: image?.url,
            stock: variant.quantity ? variant.quantity : undefined,
            price: variant.cost,
            oldPrice: variant.price,
        };
        return [...previous, item];
    }, []);
};
